import type { Permission } from '../../api/types'

export const PERMISSIONS: Permission[] = ['admin', 'user', 'viewer']

// PERMISSION_LABELS maps the stored lowercase enum to the human-readable
// label shown in the UI. The enum is the wire contract (CLAUDE.md §3); the
// labels live only here. Shared by UsersTab and UserDialog (FE-4).
export const PERMISSION_LABELS: Record<Permission, string> = {
  admin: 'Admin',
  user: 'User',
  viewer: 'Viewer',
}

// permLabel is tolerant of a value not in the enum (e.g. a legacy doc that
// somehow reached the client un-normalized) — it falls back to the raw
// string rather than rendering "undefined".
export function permLabel(p: string): string {
  return PERMISSION_LABELS[p as Permission] ?? p
}

export function permTone(p: Permission): 'blue' | 'slate' | 'amber' {
  if (p === 'admin') return 'blue'
  if (p === 'viewer') return 'amber'
  return 'slate'
}

export function PermissionSelect({
  value,
  onChange,
}: {
  value: Permission
  onChange: (p: Permission) => void
}) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as Permission)}
      className="block w-full rounded-md border border-line-strong bg-surface px-3 py-2 text-sm"
    >
      {PERMISSIONS.map((p) => (
        <option key={p} value={p}>
          {PERMISSION_LABELS[p]}
        </option>
      ))}
    </select>
  )
}
